import React from 'react'

const RevokeConsent = ({ error }) => (
  <section className="ob-error">
    <h1 className="zb-heading2">Sorry, something went wrong</h1>
    <div className="ob-column-container">
      <div className="zb-card ob-card">
        <p>
          We’re sorry we seem to be experiencing some technical difficulties and
          are unable to cancel your agreed connection.
        </p>
        <p>
          You can try again later or you can go directly to {error.clientName}.
        </p>
      </div>
    </div>
  </section>
)
export default RevokeConsent
